import { Link, useNavigate, useParams } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../../services/api";
import toastOptions from "../../../utils/toastOptions";
import PresenceList from "../../presence/presence-list/PresenceList";
import IEventDetail from "../../../models/IEventDetail";
import CheckInEvent from "../../check-in/check-event/CheckInEvent";
import { authenticationService } from "../../../services/auth.service";

type RouteParams = {
  id: string;
}

export default function DashboardEvent() {
  const params = useParams<RouteParams>();
  const navigate = useNavigate();
  const [totalPeople, setTotalPeople] = useState<number>();
  const [eventDetail, setEventDetail] = useState<IEventDetail>();
  const [idEvent, setIdEvent] = useState<number>(0);

  useEffect(() => {
    setIdEvent(params.id != 'undefined' ? +(params.id ?? 0) : 0);
    init();
  }, [params.id]);

  useEffect(() => {
    if (eventDetail){
      fetchEventPeople();
    }
  }, [eventDetail]);

  const init = async () => {
    try {
      let eventDetail: IEventDetail;

      if (params.id && +(params.id ?? 0) > 0) {
        const { data: event } = await api.get(`/events/${params.id ?? 0}`);
        eventDetail = event.item;
      } else {
        const { data: event } = await api.get("/events/active");

        if (!event || !event.id) {
          setIdEvent(-1);
          navigate(`/eventos/lista`, { replace: true });
          return;
        }

        eventDetail = event;
        navigate(`/eventos/${eventDetail.id ?? 0}/dashboard`, { replace: true });
      }
      
      await api.get(`/events/${eventDetail.id ?? 0}/presence/open`);
      
      setEventDetail(eventDetail);
  
    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.warning(m, toastOptions);
      });

      setTotalPeople(0);
    };
  }

  const fetchEventPeople = async () => {
    try {
      let paramsFetch = {
        page: 1,
        limit: 1,
      } as any;

      const { data } = await api.get(`/events/${eventDetail?.id ?? 0}/people`, {
        params: paramsFetch,
      });

      setTotalPeople(data.total);

    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.warning(m, toastOptions);
      });

      setTotalPeople(0);
    }
  };
  
  return (
    <div
      id="page-dashboad-event"
      className="uk-section uk-section-muted uk-padding-small"
    >
      <div className="uk-container">
        <div className="uk-grid-small uk-margin-bottom" uk-grid="true">
          <div className="uk-width-1-1@m uk-flex uk-flex-right">
            {(idEvent > 0 && !authenticationService.isReadOnly()) &&
              <Link
                className="uk-button uk-button-primary uk-button-small uk-margin-small-right"
                to={`/eventos/${params?.id}`}
              >
                Editar
              </Link>
            }
            <Link
              className="uk-button uk-button-default uk-button-small"
              to='/eventos/lista'
            >
              Anteriores
            </Link>
          </div>
          <div className="uk-width-1-2@m">
            <div className="uk-card uk-card-primary uk-card-small uk-card-hover">
              <div className="uk-card-header">
                <div className="uk-grid-small uk-flex-middle" uk-grid="true">
                  <div className="uk-width-expand">
                    <h3 className="uk-card-title uk-margin-remove-bottom">Inscritos • {eventDetail?.name}</h3>
                  </div>
                </div>
              </div>
              <div className="uk-card-body">
                {
                  (totalPeople == undefined) ? 
                    <div uk-spinner="true; ratio:2">Carregando...</div>
                  :
                    <h1 className="uk-heading-xlarge">{totalPeople}</h1>
                }
              </div>
              <div className="uk-card-footer">
                <Link to={`/eventos/${params?.id}/pessoas`}>Visualizar Inscritos <span uk-icon="arrow-right"></span></Link>
              </div>
            </div>
          </div>
          <div className="uk-width-1-2@m">
            <div className="uk-grid" uk-grid="true">
              <div className="uk-width-1-2@m">
                <div className="uk-card uk-card-body uk-card-success uk-flex uk-flex-middle uk-flex-center uk-card-hover">
                  <div className="uk-inline-clip uk-transition-toggle">
                    <Link to={`/eventos/${params?.id ?? 0}/impressoes`} className="uk-button">
                      <div className="uk-transition-scale-up uk-transition-opaque">
                        <span uk-icon="icon: print; ratio: 2"></span>
                        <br/>
                        Impressão
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              {!authenticationService.isReadOnly() && 
                <div className="uk-width-1-2@m">                
                  <CheckInEvent idEvent={eventDetail?.id ?? 0} nameEvent={eventDetail?.name} />
                </div>
              }
            </div>
          </div>
          <div className="uk-width-1-2@m">
            <PresenceList idEvent={eventDetail?.id} />
          </div>
        </div>
      </div>
    </div>
  );
}
